const styles = {
  signupContainer: {
    maxWidth: 600,
    margin: '12px auto',
    background: '#ffffff',
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08)',
    padding: '12px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    border: '1px solid rgba(0,0,0,0.06)',
  },
  stepContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  title: {
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 0,
    textAlign: 'center',
    color: '#1a1a1a',
    letterSpacing: '-0.02em',
    lineHeight: '1.2',
  },
  subtitle: {
    fontSize: 13,
    color: '#6b7280',
    textAlign: 'center',
    marginBottom: 0,
    lineHeight: '1.4',
    fontWeight: 400,
  },
  accountTypeGrid: {
    display: 'flex',
    gap: 16,
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginBottom: 16,
  },
  accountTypeCard: {
    minWidth: 160, // Increased from 130 (was 110 originally)
    minHeight: 160, // Increased from 130 (was 110 originally)
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
    borderRadius: 12,
    padding: 32, // Increased from 24 (was 20 originally)
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    border: '1px solid #e2e8f0',
    position: 'relative',
    overflow: 'hidden',
  },
  accountTypeHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
  },
  accountTypeLabel: {
    fontWeight: 600,
    fontSize: 24, // Increased from 20 (was 18 originally)
    color: '#1e293b',
    letterSpacing: '-0.01em',
  },
  seatBadge: {
    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
    color: '#ffffff',
    borderRadius: 16,
    padding: '6px 14px', // Increased from 4px 12px
    fontSize: 15, // Increased from 13 (was 12 originally)
    fontWeight: 600,
    marginLeft: 6,
    boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
  },
  accountTypeDesc: {
    fontSize: 17, // Increased from 15 (was 14 originally)
    color: '#64748b',
    textAlign: 'center',
    marginTop: 6,
    lineHeight: '1.4',
  },
  input: {
    padding: '10px 12px', // Reduced from 14px 16px
    fontSize: 15, // Slightly reduced from 16
    border: '2px solid #e2e8f0',
    borderRadius: 8, // Reduced from 10
    marginBottom: 12, // Reduced from 16
    width: '100%',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    transition: 'all 0.2s ease',
    backgroundColor: '#ffffff',
    color: '#1e293b',
    lineHeight: '1.4', // Reduced from 1.5
  },
  inputFocused: {
    borderColor: '#3b82f6',
    boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.1)',
    outline: 'none',
  },
  paymentRow: {
    display: 'flex',
    gap: 16,
    marginBottom: 16,
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 16,
    marginTop: 8,
  },
  nextButton: {
    background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
    color: '#ffffff',
    border: 'none',
    borderRadius: 10,
    padding: '10px 28px',
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: 4,
    transition: 'all 0.2s ease',
    minWidth: 140,
    boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
    letterSpacing: '0.01em',
  },
  backButton: {
    background: '#f8fafc',
    color: '#64748b',
    border: '2px solid #e2e8f0',
    borderRadius: 10,
    padding: '10px 28px',
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: 4,
    transition: 'all 0.2s ease',
    minWidth: 140,
    letterSpacing: '0.01em',
  },
  errorText: {
    color: '#ef4444',
    fontSize: 14,
    marginTop: -8,
    marginBottom: 12,
    fontWeight: 500,
    lineHeight: '1.4',
  },
  successText: {
    color: '#10b981',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '1.4',
  },
  stepIndicator: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 4,
    gap: 6,
  },
  stepDot: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    backgroundColor: '#e2e8f0',
    transition: 'all 0.3s ease',
  },
  stepDotActive: {
    backgroundColor: '#3b82f6',
    transform: 'scale(1.2)',
  },
  stepDotCompleted: {
    backgroundColor: '#10b981',
  },
  formSection: {
    background: '#f8fafc',
    borderRadius: 10,
    padding: '10px 14px',
    marginBottom: 6,
    border: '1px solid #e2e8f0',
  },
  sectionTitle: {
    fontSize: 15,
    fontWeight: 600,
    color: '#1e293b',
    marginBottom: 6,
    letterSpacing: '-0.01em',
  },
  sectionDescription: {
    fontSize: 13,
    color: '#64748b',
    marginBottom: 8,
    lineHeight: '1.4',
  },
};

export default styles;
